import React, {Component} from "react";
import Header from "./Header";
import AppNavbar from "./Sidebar";
import Welcome from "./Welcome";
import axios from "axios";
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./css/App.css";
import Loader from "react-loader-spinner";
import Favicon from "react-favicon";
import MetaTags from "react-meta-tags";

toast.configure()


export default class Login extends Component {

    constructor(props) {
        super(props);
        console.log(" ===== LOGGING OUT as ",sessionStorage.getItem('loggedUserStorage'))
        sessionStorage.clear();
        console.log(" ===== Cleared storage ",sessionStorage.getItem('loggedUserStorage'))
        this.state = {
            displayLogin: true,
            logging: false,
            password: null,
            userName: null,
            formFieldsEmpty: null,
            errors:{},
            formErrors: {
                userName: "",
                password: "",
                formFieldsEmpty: "",

            }
        };
    }


//Validation for All empty Fields
    formValidation = () =>{
        const {userName,password} = this.state;
        let isValid = false;
        let errors = {};
        if (!userName) {
            errors.userName = 'Please enter valid Username';
        }if (!password) {
            errors.password = 'Please enter valid password';
        }else{
            isValid = true;
        }
        this.setState({errors});

        return isValid;
    }

    handleChange = event => {
        let formErrors = { ...this.state.formErrors };
        const { name, value } = event.target;

        switch (name) {
            case "userName":
                if (value.length < 3) {
                    formErrors.userName =
                        "Minimum 3 characters required";
                }
                if (!value) {
                    formErrors.userName ="Please Provide a Valid Input";
                } else {
                    formErrors.userName =
                        "";
                }
                break;
            case "password":
                formErrors.password =
                    value.length < 3 ? "Minimum 3 characters required" : "";
                break;
            default:
                break;
        }
        this.setState({formErrors, [event.target.name]: event.target.value });
    }


    hideLogin() {
        this.setState({displayLogin: false })
        //this.props.onUpdate(this.state)
    }

    hideLoader = () => {
        this.setState({ logging: false })
    }

    showLoader = () => {
        this.setState({ logging: true });
    }


    handleSubmit = event => {
        event.preventDefault();
        this.showLoader()
        const user ={
            userName: this.state.userName,
            password: this.state.password,
        };
        const isValid = this.formValidation();
        if(isValid) {

            axios.post(`signin`, user)
                .then(res => {
                    console.log("Login Response  ",res)
                    if (res.status == 200) {
                        this.setState({displayLogin: false,loading: true,logging: false  }, () => { // write console log if any
                             });
                        sessionStorage.setItem('UserName', this.state.userName);
                        sessionStorage.setItem('Password', this.state.password);
                        //alert('User Validated Successfully !!');
                        toast.success('User Validated Successfully !!', {position: toast.POSITION.TOP_CENTER,autoClose:100})
                    }else{
                        toast.error('Please check Username and Password !!!!', {position: toast.POSITION.TOP_CENTER,autoClose:100})
                        this.setState({displayLogin: true ,loading: false})
                    }
                    sessionStorage.setItem('COOKIE',res.data.sessionId);
                    this.setState({COOKIE: res.data.sessionId })
                    //console.log("cookie set "+sessionStorage.getItem('COOKIE'))
                }).finally(() => {
                axios
                    .get(`getLoggedUserName?JSESSIONID=${ sessionStorage.getItem('COOKIE')}`)
                    .then((response) => {
                        console.log(
                            "=== LOG_1 === Inside componentDidMount %s with data and session id as %s ",
                            "Header",
                            response.data,
                        );
                        this.setState({ loggedInUser: response.data });
                        sessionStorage.setItem('loggedUserStorage', response.data);
                    })
            }).catch(error => {
                    console.log("Login Page Error "+error)
                toast.error('Please check Username and Password !!!!', {position: toast.POSITION.TOP_CENTER,autoClose:100})
                //alert("Please check Username and Password !!")
                this.setState({displayLogin: true,loading: false })
                //toast.error("Invalid Username & Password,Please check Credentials !!", {position: toast.POSITION.TOP_CENTER,autoClose:1000})
            });
        }else{
            console.log(this.state);
            //toast.error('Validation Failed!!', {position: toast.POSITION.TOP_CENTER,autoClose:100})
        }
    }



    //Function to update state from userView
    //onUpdate (data) { this.setState({ data }) }

    render() {
        const { formErrors } = this.state;
        const logoStyle={
            width:'30%',
            height:'auto',
        };
        const loader = {
            left: '46%',
            position: 'absolute',
            marginTop: "200px",
            zIndex: 1,
            width:"300px",
            height: "900px",
        };



        console.log("=== LOG_Login_1 === Inside render %s with data ","Login",this.state.loading);
        return (
            <React.Fragment>
                {this.state.logging ? <Loader style={loader} type="ThreeDots" color="#e9953c" radius="5px" timeout={1000}/>: ""}
                { this.state.displayLogin &&
            <body className="authentication-bg">
            <Favicon url='https://passporttechnology.com/images/base/favicon-16x16.png' />
            <MetaTags>
                <title>DataStream Version 2.0</title>
                <meta name="description" content="Some description." />
                <meta property="og:title" content="DataStream Version 2.0" />
            </MetaTags>
            <div className="account-pages mt-5 mb-4 pt-sm-5">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">

                                <div className="card-body p-4">
                                    <div className="text-center">
                                        <a href="#" className="mb-3 d-block auth-logo">
                                            <img src="assets/images/icons/DataCenterLogo.png" style={{width:"30%"}} alt="" />
                                        </a>
                                    </div>
                                    <div className="p-2 mt-4">
                                        <form onSubmit={this.handleSubmit}>

                                            <div className="form-group">
                                                <label htmlFor="username">Username</label>
                                                <input type="text" name="userName" className={formErrors.userName.length > 0 ? "form-control error" : "form-control"}  autoComplete="off" onChange={this.handleChange}
                                                       placeholder="Enter Username"/>
                                                {formErrors.userName.length > 0 && (
                                                    <span className="errorMessage">{formErrors.userName}</span>
                                                )}
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="userpassword">Password</label>
                                                <input type="password" name="password" className={formErrors.password.length > 0 ? "form-control error" : "form-control"}  autoComplete="off" onChange={this.handleChange}
                                                       placeholder="Enter password"/>
                                                {formErrors.password.length > 0 && (
                                                    <span className="errorMessage">{formErrors.password}</span>
                                                )}
                                            </div>

                                           {/* <div className="custom-control custom-checkbox">
                                                <input type="checkbox" className="custom-control-input"
                                                       id="auth-remember-check"/>
                                                    <label className="custom-control-label"
                                                           htmlFor="auth-remember-check">Remember me</label>
                                            </div>*/}

                                            <div className="mt-3 text-right" style={{width: "100px", marginLeft:"140px"}}>
                                                <button type="submit"
                                                        className="btn btn-primary btn-block waves-effect waves-light">Login
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-5 text-center">
                                <p>© 2026 Passport Technology Inc.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            </body>
                }
                {
                    !this.state.displayLogin &&
                    <body data-sidebar="colored">
                    <div id="layout-wrapper">
                        <Header/>
                        <AppNavbar/>
                    </div>
                    {<Welcome/>}
                    </body>
                }
            </React.Fragment>
    );
    }
}